module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/user_way_pc-e9a4e3cab1918cc5ad8f39f1074486e2.jpg";